export default {
  props: ['url'],
  methods: {
    goTo() {
      if (this.url) {
        this.$router.push(this.i18nLink(this.url));
      } else {
        this.$router.go(-1);
      }
    }
  }
};
